import { Link } from "react-router-dom";

const TopBg = () => {
  return (
    <div className="hidden md:flex  justify-center  mx-auto mb-20 mt-[25px] md:mt-[80px] w-[96.5vw] md:w-[88.5vw] h-[70vh] md:h-[100vh] ">
      <div className="  shadow-slate-400 shadow-md relative rounded-3xl md:rounded-3xl bg-cover ">
        <img
          className="object-center h-[70vh] md:h-[100vh] w-[96.5vw] md:w-[88.5vw] rounded-3xl md:rounded-3xl object-cover brightness-[70%]"
          src="/bg-main2.jpg"
        ></img>

        <div className="absolute top-[60px] md:top-[70px] left-[1.2vh] md:left-[10.526vh]">
          <h1 className="text-white text-[25px] md:text-[40px] lg:text-[49px] font-semibold">
            Vacation made easy.
          </h1>
          <h1 className="text-white text-[25px] md:text-[40px] lg:text-[49px] font-semibold py-1">
            Book your perfect Villa today
          </h1>
          {/* <h1 className="text-black text-lg font-medium pt-5  ">
            Experience comfort, style and relaxation on your next getaway
          </h1> */}
          {/* <h1 className="text-black text-lg font-medium pb-5  ">
          Unwind in luxury, book your villa now.
          </h1> */}
          {/* <Link to={"/"}>
            <div className=" bg-opacity-90 py-2 mt-4 shadow-black shadow-md bg-transparent text-sm font-medium hover:bg-black text-black hover:text-white border-black border-[1px] rounded-full w-2/5 px-4">
              Try A2zRoomz
            </div>
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default TopBg;
